//#region src/presentation/components/controls/text-input/text-input-type.ts
var TextInputType = /* @__PURE__ */ function(TextInputType) {
	TextInputType["EMAIL"] = "email";
	TextInputType["NUMBER"] = "number";
	TextInputType["PASSWORD"] = "password";
	TextInputType["TEXT"] = "text";
	TextInputType["DATE"] = "date";
	TextInputType["RADIO"] = "radio";
	return TextInputType;
}({});
//#endregion
export { TextInputType };

//# sourceMappingURL=text-input-type.js.map